import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';

export default class FaqCategoryCMSModel implements CMSModel {
  name = '';
  sort = '';
  faq_category_name = '';

  map(obj: any): FaqCategoryCMSModel {
    this.name = _.get(obj, 'name', '');
    this.sort = _.get(obj, 'sort', 'Undefined');
    this.faq_category_name = _.get(obj, 'translation[0].faq_category_name', 'Undefined');
    return this;
  }
}
